import { HTTP } from '@/http/http-client';
import { mapParams } from '@/utils/mapParams';
import { mapBodyParams } from '@/utils/mapBodyParams';

const getActivitiesInfo = () =>
    HTTP.get(`no-auth/schools/slug/parent-portal-settings/parents`).then(({ data }) => data);

const getClassesBySchool = (options) =>
    HTTP.get(`no-auth/parents/schools/slug/classes?${mapParams({ ...options })}`).then(({ data }) => data);

const getCampsBySchool = (options) =>
    HTTP.get(`no-auth/parents/schools/slug/camps?${mapParams({ ...options })}`).then(({ data }) => data);

const getAftercareBySchool = (options) =>
    HTTP.get(`no-auth/parents/schools/slug/aftercare?${mapParams({ ...options })}`).then(({ data }) => data);

const getTeachers = () =>
    HTTP.get(`schools/slug/settings/teachers/parents`).then(({ data }) => data);

const getPickUpOptions = () =>
    HTTP.get(`schools/slug/settings/pick-up-options/parents`).then(({ data }) => data);

const getTShirtSizes = () =>
    HTTP.get(`no-auth/schools/slug/settings/t-shirt-sizes/parents`).then(({ data }) => data);

const getActivityExtras = (id) =>
    HTTP.get(`schools/slug/classes/${id}/add-ons/parents`).then(({ data }) => data);

const getActivityExtrasCamp = (campPricingId) =>
    HTTP.get(`schools/slug/camp-pricing/${campPricingId}/addons/parents`).then(({ data }) => data);

const getActivityExtrasAftercare = (aftercareId) =>
    HTTP.get(`schools/slug/aftercare/${aftercareId}/addons/parents`).then(({ data }) => data);

const getActivityExtrasAftercareUses = ({ aftercareId, childId }) =>
    HTTP.get(`schools/slug/aftercare/${aftercareId}/children/${childId}/addons-uses/parents`).then(({ data }) => data);

const getChildInfoForEnroll = ({ aftercareId, childId }) =>
    HTTP.get(`schools/slug/aftercare/${aftercareId}/roster-info?childId=${childId}`).then(({ data }) => data);

const getClassRequired = (classId) =>
    HTTP.get(`no-auth/parents/schools/slug/classes/${classId}/details`).then(({ data }) => data);

const getCampRequired = (campId) =>
    HTTP.get(`no-auth/parents/schools/slug/camps/${campId}/details`).then(({ data }) => data);

const getAftercareRequired = (aftercareId) =>
    HTTP.get(`no-auth/parents/schools/slug/aftercare/${aftercareId}/details`).then(({ data }) => data);

const addToCart = ({ form, classId }) =>
    HTTP.post(`schools/slug/classes/${classId}/enrollment`, mapBodyParams(form)).then(({ data }) => data);

const checkChildBeforeToCart = ({ childId, classId }) =>
    HTTP.get(`schools/slug/classes/${classId}/check/${childId}`);

const addToWaitList = ({ form, classId }) =>
    HTTP.post(`schools/slug/classes/${classId}/waitlist/parents`, mapBodyParams(form)).then(({ data }) => data);

const getClassRoster = ({ schoolId ,classId, rosterId, childId }) =>
    HTTP.get(`schools/${schoolId}/classes/${classId}/rosters/${rosterId}/child/${childId}`).then(({ data }) => data);

const addToCartCamp = ({ form, campPricingId }) =>
    HTTP.post(`schools/slug/camp-pricing/${campPricingId}/enrollment`, mapBodyParams(form)).then(({ data }) => data);

const checkChildBeforeCartCamp = ({ childId, campPricingId }) =>
    HTTP.get(`schools/slug/camp-pricing/${campPricingId}/check/${childId}`)

const addToWaitListCamp = ({ form }) =>
    HTTP.post(`schools/slug/camps/wait-list/parents`, mapBodyParams(form)).then(({ data }) => data);

const addToCartAftercareEnroll = ({ form, aftercareId }) =>
    HTTP.post(`schools/slug/aftercare/${aftercareId}/enrollment`, mapBodyParams(form)).then(({ data }) => data);

const checkChildBeforeAftercareEnroll = ({ aftercareDayId, aftercareId, childId }) =>
    HTTP.post(`schools/slug/aftercare/${aftercareId}/aftercare-day/${aftercareDayId}/check/${childId}`);

const addToCartAftercareDropIn = ({ form, aftercareId }) =>
    HTTP.post(`schools/slug/aftercare/${aftercareId}/drop-in-enrollment`, mapBodyParams(form)).then(({ data }) => data);

const addToWaitListAftercare = ({ form, aftercareId }) =>
     {
        return HTTP.post(`schools/slug/aftercare/${aftercareId}/waitlist/parents`, mapBodyParams(form)).then(({ data }) => data);
     }

const getPolicies = () =>
    HTTP.get(`no-auth/schools/slug/policy/parents`).then(({ data }) => data);

const getActivitiesCalendarDates = (params) =>
    HTTP.get(`schools/slug/activities/calendar?${mapParams(params)}`).then(({ data }) => data);

const getAftercareFullDropInDates = ({ aftercareId, childId }) =>
    HTTP.get(`schools/slug/aftercare/${aftercareId}/children/${childId}/full-drop-in`).then(({ data }) => data);

const getAftercareRostersFreeDays = ({schoolId, aftercareId, childId}) => 
    HTTP.get(`/schools/${schoolId}/aftercare/${aftercareId}/free-days/children/${childId}`).then(({ data }) => data);

const getAftercareWaitlistFreeDays = ({schoolId, aftercareId, childId}) =>
    HTTP.get(`/schools/${schoolId}/aftercare/${aftercareId}/free-days-waitlist/children/${childId}`).then(({ data }) => data);

 const getAftercareRoster = (schoolId, aftercareId, rosterId, rosterDayId, childId) =>
    HTTP.get(`/schools/${schoolId}/aftercare/${aftercareId}/rosters/${rosterId}/rosterDay/${rosterDayId}/child/${childId}`).then(({ data }) => data);


const getCampRosterStatus =({schoolId, campPricingId, rosterId, childId}) =>
    HTTP.get(`/schools/${schoolId}/camp-pricing/${campPricingId}/rosters/${rosterId}/child/${childId}`).then(({ data }) => data);


export default {
    getActivitiesInfo,
    getClassesBySchool,
    getCampsBySchool,
    getAftercareBySchool,
    getTeachers,
    getPickUpOptions,
    getTShirtSizes,
    getActivityExtras,
    getActivityExtrasCamp,
    getActivityExtrasAftercare,
    getActivityExtrasAftercareUses,
    getChildInfoForEnroll,
    getClassRequired,
    getCampRequired,
    getAftercareRequired,
    addToCart,
    addToWaitList,
    addToCartCamp,
    addToWaitListCamp,
    addToCartAftercareEnroll,
    addToCartAftercareDropIn,
    addToWaitListAftercare,
    getPolicies,
    getActivitiesCalendarDates,
    getAftercareFullDropInDates,
    checkChildBeforeToCart,
    checkChildBeforeCartCamp,
    checkChildBeforeAftercareEnroll,
    getClassRoster,
    getAftercareRostersFreeDays,
    getAftercareWaitlistFreeDays,
    getAftercareRoster,
    getCampRosterStatus
};


// WEBPACK FOOTER //
// ./src/http/services/activitiesService.js